import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import sectionsData from './sectionsData'; // Importa las secciones desde otro archivo

import './styles.scss';

const Section = ({ id, title, content }) => (
  <div id={id} className="mt-2">
    <h2 className='mb-1 mb-md-4 pt-1 pt-md-4'>{title}</h2>	
    <div dangerouslySetInnerHTML={{ __html: content }} />
  </div>
);

const TermsAndConditions = () => {
  const { sectionId } = useParams();

  useEffect(() => {
    if (sectionId !== undefined && sectionsData[sectionId]) {
      const element = document.getElementById(sectionsData[sectionId].id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [sectionId]);

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="container mt-4">
      <div className="row">
        <div id="menu-tyc" className="col-md-3 sticky-menu">
          <h4>⁃ Términos y Condiciones</h4>
          <ul className="list-group">
            {sectionsData.map((section, index) => (
              <li key={section.id} className="list-group-item">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll(section.id);
                    window.history.pushState({}, '', `/terminos-condiciones/seccion/${index}`);
                  }}
                >
                  {section.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-md-9">
          {sectionsData.map((section) => (
            <Section key={section.id} {...section} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
